module.exports = __webpack_public_path__ + "img/usaEng.44b53b81.png";